export const CONTACT = {
  business: "Frame Shift",
  owner: "Benny Obsaint",
  phone: "941-292-9244",
  phoneHref: "tel:+19412929244",
  email: "bennyobsaint3@gmail.com",
  hours: "24/7",
};

export const PAIRS = {
  car: { before: "/images/car-before.jpg", after: "/images/world-sunset.jpg", from: "Driveway", to: "Golden Sunset", title: "Coupe", tag: "Car" },
  moto: { before: "/images/moto-before.jpg", after: "/images/moto-after.jpg", from: "Parking Lot", to: "Mountain Pass", title: "Superbike", tag: "Motorcycle" },
  person: { before: "/images/person-before.jpg", after: "/images/person-after.jpg", from: "Living Room", to: "Cinematic Street", title: "Portrait", tag: "Personal" },
  sports: { before: "/images/sports-before.jpg", after: "/images/sports-after.jpg", from: "Side Street", to: "Luxury Night", title: "Sports Car", tag: "Car" },
  dirt: { before: "/images/dirt-before.jpg", after: "/images/dirt-after.jpg", from: "Backyard", to: "Desert Canyon", title: "Dirt Bike", tag: "Off-road" },
};

export const WORLDS = [
  { id: "sunset", name: "Sunset", img: "/images/world-sunset.jpg", note: "Golden hour on the coast" },
  { id: "night", name: "Night", img: "/images/world-night.jpg", note: "Starlight and city glow" },
  { id: "desert", name: "Desert", img: "/images/world-desert.jpg", note: "Endless dunes, hard sun" },
  { id: "snowy-alps", name: "Snowy Alps", img: "/images/world-snow.jpg", note: "Winter mountain pass" },
  { id: "ocean-coast", name: "Ocean Coast", img: "/images/world-ocean.jpg", note: "Cliffside sea road" },
  { id: "misty-forest", name: "Misty Forest", img: "/images/world-forest.jpg", note: "Redwoods at dawn" },
  { id: "fortnite", name: "Fortnite", img: "/images/world-fortnite.jpg", note: "Bright game-world meadow" },
];

export const STYLES = [...WORLDS, { id: "custom", name: "Custom Idea", img: null }];

export const selectMode = (id) => window.dispatchEvent(new CustomEvent("fs:mode", { detail: id }));

export const TOOLS = [
  { id: "background", label: "Background Swap", note: "Cars, bikes, people, anything" },
  { id: "person", label: "Person Swap", note: "Someone new takes the spot" },
  { id: "generate", label: "Image Generator", note: "Type a place, get a scene" },
  { id: "video", label: "Video Swap", note: "New background for a 3-10s clip" },
];

export const NAV = [
  { id: "how", label: "How it works" },
  { id: "order", label: "Studio" },
  { id: "pricing", label: "Pricing" },
  { id: "faq", label: "FAQ" },
];

export const TICKER = ["New: Video Swap", "Instant AI background swaps", "Credit packs from $8", "Made for cars, trucks and bikes", "Failed swaps refunded", "Support 24/7"];

export const FAQ = [
  { q: "What photos work best?", a: "A clear, well-lit photo where your car, bike or person is fully in frame. Phone photos are perfect. The sharper the subject, the cleaner the swap." },
  { q: "Do I have to write a prompt?", a: "No. Pick one of our worlds and hit Swap. You can add extra details like \"golden hour\" or \"wet road\" if you want, or type your own idea." },
  { q: "Can I use my own background?", a: "Yes. Upload any photo of the place you want to be, or make one with the Image Generator and use it as your background in one click." },
  { q: "Can I swap the background of a video?", a: "Yes. Upload a 3 to 10 second MP4 or MOV clip (at least 720p, under 50MB), pick a world or describe your own, and only the background changes. Your ride, its motion and every frame of your footage stay exactly as you filmed them. A video uses 10 credits and usually takes a few minutes; we keep working even if you leave the page, and it lands in My Orders." },
  { q: "How do credits work?", a: "A Background Swap, Person Swap or generated picture uses 1 credit, and a Video Swap uses 10. Plans add credits every month, and credit packs are a one-time buy that never expire." },
  { q: "What if a swap fails?", a: "If the AI can't finish your image, the credit goes straight back to your account automatically." },
  { q: "Where do I find my images?", a: "Every result appears instantly in the Studio and is saved in My Orders, where you can compare and download it any time." },
];
